// extracted by mini-css-extract-plugin
export var locationCard = "_h9-0";